export const IS_FETCHING_NOTIFICATION_PREFERENCES = 'dashboard/Settings/IS_FETCHING_NOTIFICATION_PREFERENCES'
export const NOTIFICATION_PREFERENCES_RECEIVED = 'dashboard/Settings/NOTIFICATION_PREFERENCES_RECEIVED'
